module.exports = "//static.hsappstatic.net/LoginUI/static-1.15875/img/SUI_desktop.svg"